<template>
  <div>
    <p class="label">{{ label }}</p>
    <p class="subLabel">{{ subLabel }}</p>
  </div>
</template>

<script>
export default {
  props: ["label", "subLabel"],
};
</script>

<style scoped>
.label {
  font-size: 14px;
  margin: 0;
  padding: 0;
  line-height: 20px;
}

.subLabel {
  font-size: 12px;
  margin: 0;
  padding: 0;
  line-height: 12px;
  font-weight: 400;
}
</style>
